module.exports = __webpack_public_path__ + "media/images/sample/search-5f91ca96acb693c0bf7ba598659de3df.svg";